import React, { useRef } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { IntroSection } from './components/IntroSection';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Toolkit } from './components/Toolkit';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { AuthorNote } from './components/AuthorNote';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  const heroCtaRef = useRef<HTMLAnchorElement>(null);
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ijxpcqos80jw">
      <MetaPixel data-id="element-1" data-mp="3ii4t85bsoyq5" />
      <Hero ref={heroCtaRef} data-id="element-2" data-mp="3mlawd43m29se" />
      <main data-id="element-3" data-mp="3mkhmhu9cv461">
        <IntroSection data-id="element-4" data-mp="3mk84otygs3bf" />
        <BeforeAfter data-id="element-5" data-mp="3mjgannkimdn9" />
        <PainPoints data-id="element-6" data-mp="3rc9ca2kot5v4" />
        <Volumes data-id="element-7" data-mp="3rbrcwx2qabiz" />
        <Toolkit data-id="element-8" data-mp="3rdatypw7kqlt" />
        <Bonuses data-id="element-9" data-mp="3rcsuzli5vya7" />
        <Testimonials data-id="element-10" data-mp="3recc1ebn6dd1" />
        <Offer data-id="element-11" data-mp="5or2zhbcs60" />
        <Guarantee data-id="element-12" data-mp="67yhm9c7y5s" />
        <AuthorNote data-id="element-13" data-mp="4n5w26l2pak" />
        <FAQ data-id="element-14" data-mp="56lhc8rh1lf" />
        <FinalCTA data-id="element-15" data-mp="7svdij4jt6t" />
      </main>
      <Footer data-id="element-16" data-mp="2zllcouynw8jk" />
      <FloatingCTA triggerRef={heroCtaRef} data-id="element-17" data-mp="2zm4zaoz9bl3x" />
      <PurchasePopup data-id="element-18" data-mp="2zn678kkz7rhf" />
    </div>;
}